/* SNOWING WEST — quantity + Add button for single-variant product cards (wholesale quick order).
   Replaces Dawn's auto-updating bulk quick add: nothing is added until the customer presses Add. */
(function () {
  if (customElements.get('sw-qty-add')) return;

  function sectionInnerHTML(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector);
    return el ? el.innerHTML : null;
  }

  function applyCartSections(sections) {
    // Cart icon count
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      var b = sectionInnerHTML(sections['cart-icon-bubble'], '.shopify-section');
      if (b !== null) bubble.innerHTML = b;
    }
    // Cart drawer contents (updated silently, not opened)
    var drawer = document.querySelector('cart-drawer');
    var drawerInner = document.getElementById('CartDrawer');
    if (drawer && drawerInner && sections['cart-drawer']) {
      var d = sectionInnerHTML(sections['cart-drawer'], '#CartDrawer');
      if (d !== null) {
        drawerInner.innerHTML = d;
        drawer.classList.remove('is-empty');
        var items = drawer.querySelector('cart-drawer-items');
        if (items) items.classList.remove('is-empty');
        var overlay = drawer.querySelector('#CartDrawer-Overlay');
        if (overlay && typeof drawer.close === 'function') overlay.addEventListener('click', drawer.close.bind(drawer));
      }
    }
  }

  class SwQtyAdd extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.sw-qty-add__input');
      this.button = this.querySelector('.sw-qty-add__btn');
      this.error = this.querySelector('.sw-qty-add__error');
      if (!this.input || !this.button) return;

      this.min = parseInt(this.dataset.min || '1', 10) || 1;
      this.step = parseInt(this.dataset.step || '1', 10) || 1;
      this.max = this.dataset.max ? parseInt(this.dataset.max, 10) : null;

      this.querySelectorAll('.sw-qty-add__step').forEach(function (btn) {
        btn.addEventListener('click', this.onStep.bind(this));
      }, this);
      this.input.addEventListener('change', this.normalize.bind(this));
      this.input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); this.add(); }
      }.bind(this));
      this.button.addEventListener('click', this.add.bind(this));
    }

    onStep(e) {
      var dir = parseInt(e.currentTarget.dataset.step, 10) || 1;
      var v = (parseInt(this.input.value, 10) || this.min) + dir * this.step;
      this.input.value = v;
      this.normalize();
    }

    normalize() {
      var v = parseInt(this.input.value, 10);
      if (isNaN(v) || v < this.min) v = this.min;
      if (this.step > 1) v = Math.max(this.min, Math.round(v / this.step) * this.step);
      if (this.max && v > this.max) v = this.max;
      this.input.value = v;
      return v;
    }

    setBusy(busy) {
      this.button.classList.toggle('loading', busy);
      this.button.disabled = busy;
      var spinner = this.button.querySelector('.loading__spinner');
      if (spinner) spinner.classList.toggle('hidden', !busy);
    }

    showError(msg) {
      if (!this.error) return;
      this.error.textContent = msg;
      this.error.hidden = !msg;
    }

    flashDone() {
      var label = this.button.querySelector('.sw-qty-add__label');
      var done = this.button.querySelector('.sw-qty-add__done');
      if (!label || !done) return;
      label.hidden = true; done.hidden = false;
      this.button.classList.add('sw-qty-add__btn--done');
      clearTimeout(this._t);
      this._t = setTimeout(function () {
        label.hidden = false; done.hidden = true;
        this.button.classList.remove('sw-qty-add__btn--done');
      }.bind(this), 1800);
    }

    add() {
      if (this.button.disabled) return;
      var qty = this.normalize();
      var id = parseInt(this.dataset.variantId, 10);
      if (!id || qty < 1) return;
      this.showError('');
      this.setBusy(true);

      var cfg = (typeof fetchConfig === 'function') ? fetchConfig('javascript') : {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' }
      };
      cfg.headers['X-Requested-With'] = 'XMLHttpRequest';
      cfg.headers['Content-Type'] = 'application/json';
      cfg.body = JSON.stringify({
        items: [{ id: id, quantity: qty }],
        sections: 'cart-drawer,cart-icon-bubble,cart-notification-button,cart-notification-product',
        sections_url: window.location.pathname
      });

      var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
      fetch(addUrl, cfg)
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) {
            this.showError(res.description || res.message || 'Could not add to cart');
            return;
          }
          applyCartSections(res.sections || {});
          this.flashDone();
          this.input.value = this.min;
          if (typeof publish === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sw-qty-add', productVariantId: id, cartData: res });
          }
        }.bind(this))
        .catch(function () { this.showError('Could not add to cart. Please try again.'); }.bind(this))
        .finally(function () { this.setBusy(false); }.bind(this));
    }

  }

  customElements.define('sw-qty-add', SwQtyAdd);

  /* ---- Multi-variant: quantities for every option, one Add ---- */
  function formatMoney(cents) {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function' && window.theme && theme.moneyFormat) {
        return Shopify.formatMoney(cents, theme.moneyFormat);
      }
    } catch (e) {}
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  class SwBulkForm extends HTMLElement {
    constructor() {
      super();
      this.rows = Array.prototype.slice.call(this.querySelectorAll('.sw-bulk__row'));
      this.button = this.querySelector('.sw-bulk__add');
      this.error = this.querySelector('.sw-qty-add__error');
      this.countEl = this.querySelector('[data-count]');
      this.subtotalEl = this.querySelector('[data-subtotal]');
      if (!this.button) return;

      this.rows.forEach(function (row) {
        var input = row.querySelector('.sw-qty-add__input');
        if (!input) return;
        row.querySelectorAll('.sw-qty-add__step').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var dir = parseInt(btn.dataset.step, 10) || 1;
            var step = parseInt(row.dataset.step || '1', 10) || 1;
            var min = parseInt(row.dataset.min || '1', 10) || 1;
            var v = parseInt(input.value, 10) || 0;
            if (dir > 0) v = v === 0 ? min : v + step; else v = v - step;
            if (v < min) v = 0;
            input.value = v;
            this.normalizeRow(row);
          }.bind(this));
        }, this);
        input.addEventListener('change', function () { this.normalizeRow(row); }.bind(this));
        input.addEventListener('input', function () { this.updateSummary(); }.bind(this));
        input.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') { e.preventDefault(); this.add(); }
        }.bind(this));
      }, this);
      this.button.addEventListener('click', this.add.bind(this));
      this.updateSummary();
    }

    normalizeRow(row) {
      var input = row.querySelector('.sw-qty-add__input');
      var step = parseInt(row.dataset.step || '1', 10) || 1;
      var min = parseInt(row.dataset.min || '1', 10) || 1;
      var max = row.dataset.max ? parseInt(row.dataset.max, 10) : null;
      var v = parseInt(input.value, 10);
      if (isNaN(v) || v <= 0) v = 0;
      else {
        if (v < min) v = min;
        if (step > 1) v = Math.max(min, Math.round(v / step) * step);
        if (max && v > max) v = max;
      }
      input.value = v;
      this.updateSummary();
    }

    collect() {
      var items = [], count = 0, subtotal = 0;
      this.rows.forEach(function (row) {
        var input = row.querySelector('.sw-qty-add__input');
        if (!input) return;
        var q = parseInt(input.value, 10) || 0;
        if (q > 0) {
          items.push({ id: parseInt(row.dataset.variantId, 10), quantity: q });
          count += q;
          subtotal += q * (parseInt(row.dataset.price, 10) || 0);
        }
      });
      return { items: items, count: count, subtotal: subtotal };
    }

    updateSummary() {
      var c = this.collect();
      if (this.countEl) this.countEl.textContent = c.count;
      if (this.subtotalEl) this.subtotalEl.textContent = formatMoney(c.subtotal);
      this.button.disabled = c.count === 0 || this.busy;
    }

    setBusy(busy) {
      this.busy = busy;
      this.button.classList.toggle('loading', busy);
      var spinner = this.button.querySelector('.loading__spinner');
      if (spinner) spinner.classList.toggle('hidden', !busy);
      this.updateSummary();
    }

    showError(msg) {
      if (!this.error) return;
      this.error.textContent = msg;
      this.error.hidden = !msg;
    }

    add() {
      if (this.busy) return;
      var c = this.collect();
      if (!c.items.length) return;
      this.showError('');
      this.setBusy(true);

      var cfg = (typeof fetchConfig === 'function') ? fetchConfig('javascript') : {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' }
      };
      cfg.headers['X-Requested-With'] = 'XMLHttpRequest';
      cfg.headers['Content-Type'] = 'application/json';
      cfg.body = JSON.stringify({
        items: c.items,
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      });
      var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
      fetch(addUrl, cfg)
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) {
            this.showError(res.description || res.message || 'Could not add to cart');
            return;
          }
          applyCartSections(res.sections || {});
          this.rows.forEach(function (row) { var i = row.querySelector('.sw-qty-add__input'); if (i) i.value = 0; });
          var label = this.button.querySelector('.sw-qty-add__label');
          var done = this.button.querySelector('.sw-qty-add__done');
          if (label && done) {
            label.hidden = true; done.hidden = false;
            this.button.classList.add('sw-qty-add__btn--done');
            this.button.disabled = true;
            setTimeout(function () {
              label.hidden = false; done.hidden = true;
              this.button.classList.remove('sw-qty-add__btn--done');
              var modal = this.closest('modal-dialog');
              if (modal && typeof modal.hide === 'function') modal.hide();
              this.updateSummary();
            }.bind(this), 1200);
          }
          if (typeof publish === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sw-bulk-form', cartData: res });
          }
        }.bind(this))
        .catch(function () { this.showError('Could not add to cart. Please try again.'); }.bind(this))
        .finally(function () { this.setBusy(false); }.bind(this));
    }
  }
  customElements.define('sw-bulk-form', SwBulkForm);
})();
